import React from 'react'
import { useTheme } from 'styled-components';
import Cta from '../../common/Cta';

import { Container } from '../../styleguide/layout'
import { H3, P } from '../../styleguide/typography';
import Community from './Community';
import Countries from './Countries';
import LowTransaction from './LowTransaction';
import Wallet from './Wallet';

const About = () => {

    const theme = useTheme();

  return (
    <Container bg={theme.colors.white} padding="8rem 6%" paddingMobile="4rem 6%">
        <H3 transform="uppercase" maxWidth="950px" margin="0 auto" align="center">
            MULA Finance is first African Based 
            <span style={{ color: theme.colors.secondary }}> decentralized mobile money </span>
            transfer system
        </H3>
        <P margin="1.5rem auto" maxWidth="1000px" align="center">
          Mula Finance leverages the use of the blockchain technology and the integration 
          of existing financial systems to offer an African-wide, cross boarder money 
          transfer and remittance solution.
        </P>

        <LowTransaction />

        <Wallet />

        <Countries />

        <Community />

        <Cta />
    </Container>
  )
}

export default About